import React, { useEffect, useState } from 'react'
import { API_URL } from '../../env'
import axios from 'axios'
import { ThreeCircles } from 'react-loader-spinner'
import { Chart, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend } from 'chart.js'
import { Line } from 'react-chartjs-2'
import { Zoom } from 'react-awesome-reveal'
import '../../styles/Admin/AdminStatistic.css'
import { Col, Row } from 'react-bootstrap'
import { numericFormatter } from 'react-number-format'

function AdminStatistic() {

    Chart.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend)

    const [isLoading, setIsLoading] = useState(true)
    const [statisticViews, setStatisticViews] = useState([])
    const [statisticContactsQuotes, setStatisticContactsQuotes] = useState([])
    const [statisticPrice, setStatisticPrice] = useState([])
    const [statisticPriceTotal, setStatisticPriceTotal] = useState(null)

    const statisticViewOptions = {
        responsive: true,
        plugins: {
            legend: false,
            title: {
                display: true,
                text: 'Les visites sur le site',
                color: '#ffffff',
                font: { size: 20 },
                padding: { bottom: 30 }
            }
        },
        scales: {
            y: {
                grid: {
                    color: '#424242',
                    borderColor: '#ffffff'
                },
                ticks: {
                    color: '#ffffff'
                }
            },
            x: {
                grid: {
                    color: '#424242',
                    borderColor: '#ffffff'
                },
                ticks: {
                    color: '#ffffff'
                }
            }
        }
    }
    const statisticContactQuoteOptions = {
        responsive: true,
        plugins: {
            legend: {
                display: true,
                position: 'top',
                labels: {
                    usePointStyle: true,
                    pointStyle: 'circle',
                    pointRadius: 5,
                    pointHoverRadius: 10,
                }
            },
            title: {
                display: true,
                text: 'Les demandes de rappel, contacts et devis',
                color: '#ffffff',
                font: { size: 20 },
                padding: { bottom: 20 }
            }
        },
        scales: {
            y: {
                grid: {
                    color: '#424242',
                    borderColor: '#ffffff'
                },
                ticks: {
                    color: '#ffffff'
                }
            },
            x: {
                grid: {
                    color: '#424242',
                    borderColor: '#ffffff'
                },
                ticks: {
                    color: '#ffffff'
                }
            }
        }
    }
    const statisticPriceOptions = {
        responsive: true,
        plugins: {
            legend: {
                display: true,
                position: 'top',
                labels: {
                    usePointStyle: true,
                    pointStyle: 'circle',
                    pointRadius: 5,
                    pointHoverRadius: 10,
                }
            },
            title: {
                display: true,
                text: 'Les paiements',
                color: '#ffffff',
                font: { size: 20 },
                padding: { bottom: 20 }
            }
        },
        scales: {
            y: {
                grid: {
                    color: '#424242',
                    borderColor: '#ffffff'
                },
                ticks: {
                    color: '#ffffff'
                }
            },
            x: {
                grid: {
                    color: '#424242',
                    borderColor: '#ffffff'
                },
                ticks: {
                    color: '#ffffff'
                }
            }
        }
    }

    useEffect(() => {

        getStatistic()

    }, [])

    function getStatistic() {

        axios.get(API_URL + 'statistic').then((response) => {
            const statisticLabels = []
            const statisticViewValues = []
            const statisticPhoneValues = []
            const statisticQuoteValues = []
            const statisticEmailValues = []
            response.data.map((item) => {
                statisticLabels.push(new Date(item.createdAt).toLocaleDateString('fr-FR', { year: 'numeric', month: 'numeric', day: 'numeric' }))
                statisticViewValues.push(item.view)
                statisticPhoneValues.push(item.contactPhone)
                statisticQuoteValues.push(item.contactQuote)
                statisticEmailValues.push(item.contactEmail)
                return item
            })
            const statisticViewsFormat = {
                labels: statisticLabels,
                datasets: [
                    {
                        label: 'Nombre de visites',
                        data: statisticViewValues,
                        borderColor: '#35a2eb',
                        backgroundColor: '#35a2eb80',
                    }
                ]
            }
            const statisticContactQuoteFormat = {
                labels: statisticLabels,
                datasets: [
                    {
                        label: 'Rappel',
                        data: statisticPhoneValues,
                        borderColor: '#35a2eb',
                        backgroundColor: '#35a2eb80',
                    }, {
                        label: 'Devis',
                        data: statisticQuoteValues,
                        borderColor: '#ff6384',
                        backgroundColor: '#ff638480',
                    }, {
                        label: 'Contact',
                        data: statisticEmailValues,
                        borderColor: '#7dff63',
                        backgroundColor: '#7dff6380',
                    }
                ]
            }
            var dateMonth = new Date().getMonth()
            const statisticPriceLabel = []
            for (var i = 11; i >= 0; i--) {
                if (dateMonth + 1 < 10) {
                    statisticPriceLabel[i] = "0" + (dateMonth + 1)
                } else {
                    statisticPriceLabel[i] = dateMonth + 1
                }
                dateMonth--
                if (dateMonth === -1) {
                    dateMonth = 11
                }
            }
            const statisticPriceFormat = {
                labels: statisticPriceLabel.map((item) => item + "/2024"),
                datasets: [
                    {
                        label: 'Validés',
                        data: response.data[0].payments.paid,
                        borderColor: '#7dff63',
                        backgroundColor: '#7dff6380',
                    }, {
                        label: 'En attente',
                        data: response.data[0].payments.inProgress,
                        borderColor: '#35a2eb',
                        backgroundColor: '#35a2eb80',
                    }, {
                        label: 'Impayés',
                        data: response.data[0].payments.unpaid,
                        borderColor: '#85a6bb',
                        backgroundColor: '#85a6bb80',
                    }, {
                        label: 'Refusés',
                        data: response.data[0].payments.refused,
                        borderColor: '#ff6384',
                        backgroundColor: '#ff638480',
                    }
                ]
            }
            const statisticPriceTotal1 = response.data[0].payments.paid[0].toString()
            const statisticPriceTotal2 = (response.data[0].payments.paid[0] + response.data[0].payments.paid[1] + response.data[0].payments.paid[2] + response.data[0].payments.paid[3] + response.data[0].payments.paid[4] + response.data[0].payments.paid[5]).toString()
            const statisticPriceTotal3 = (response.data[0].payments.paid[0] + response.data[0].payments.paid[1] + response.data[0].payments.paid[2] + response.data[0].payments.paid[3] + response.data[0].payments.paid[4] + response.data[0].payments.paid[5] + response.data[0].payments.paid[6] + response.data[0].payments.paid[7] + response.data[0].payments.paid[8] + response.data[0].payments.paid[9] + response.data[0].payments.paid[10] + response.data[0].payments.paid[11]).toString()
            const statisticPriceTotal4 = response.data[0].payments.paid.reduce((acc, curr) => acc + curr, 0).toString()
            const statisticPriceTotalFormat = {
                month1: numericFormatter(statisticPriceTotal1, { thousandSeparator: " ", decimalScale: 2, suffix: " €" }),
                month6: numericFormatter(statisticPriceTotal2, { thousandSeparator: " ", decimalScale: 2, suffix: " €" }),
                year1: numericFormatter(statisticPriceTotal3, { thousandSeparator: " ", decimalScale: 2, suffix: " €" }),
                total: numericFormatter(statisticPriceTotal4, { thousandSeparator: " ", decimalScale: 2, suffix: " €" }),
            }
            setStatisticViews(statisticViewsFormat)
            setStatisticContactsQuotes(statisticContactQuoteFormat)
            setStatisticPrice(statisticPriceFormat)
            setStatisticPriceTotal(statisticPriceTotalFormat)
            setIsLoading(false)

        }).catch((error) => {
            console.log("error :\n" + JSON.stringify(error) + "\n\n")
        })

    }

    if (isLoading) {

        return (

            <ThreeCircles visible={true} height={"100"} width={"100"} color={getComputedStyle(document.documentElement).getPropertyValue('--loaderDark')} wrapperClass={"loader"} />

        )

    } else {

        return (

            <div id='adminStatistic'>
                <Row>
                    <Col>
                        <Row>
                            <Col>
                                <Zoom duration={500}>
                                    <div id='adminStatisticPriceBlock'>
                                        <div id='adminStatisticPriceBlockText'>{new Date().toLocaleString('fr-FR', { month: 'long' })}</div>
                                        <div id='adminStatisticPriceBlockNumber'>{statisticPriceTotal.month1}</div>
                                    </div>
                                </Zoom>
                            </Col>
                            <Col>
                                <Zoom duration={500} delay={50}>
                                    <div id='adminStatisticPriceBlock'>
                                        <div id='adminStatisticPriceBlockText'>6 mois</div>
                                        <div id='adminStatisticPriceBlockNumber'>{statisticPriceTotal.month6}</div>
                                    </div>
                                </Zoom>
                            </Col>

                        </Row>
                        <Row>
                            <Col>
                                <Zoom duration={500} delay={100}>
                                    <div id='adminStatisticPriceBlock'>
                                        <div id='adminStatisticPriceBlockText'>1 an</div>
                                        <div id='adminStatisticPriceBlockNumber'>{statisticPriceTotal.year1}</div>
                                    </div>
                                </Zoom>
                            </Col>

                            <Col>
                                <Zoom duration={500} delay={150}>
                                    <div id='adminStatisticPriceBlock'>
                                        <div id='adminStatisticPriceBlockText'>Total</div>
                                        <div id='adminStatisticPriceBlockNumber'>{statisticPriceTotal.total}</div>
                                    </div>

                                </Zoom>
                            </Col>
                        </Row>
                    </Col>
                    <Col>
                        <Zoom duration={500} delay={0}>
                            <div className='adminStatisticChartViewSmall'>
                                <Line options={statisticPriceOptions} data={statisticPrice} />
                            </div>
                        </Zoom>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Zoom duration={500}>
                            <div className='adminStatisticChartViewSmall'>
                                <Line options={statisticViewOptions} data={statisticViews} />
                            </div>
                        </Zoom>
                    </Col>
                    <Col>
                        <Zoom duration={500} delay={50}>
                            <div className='adminStatisticChartViewSmall'>
                                <Line options={statisticContactQuoteOptions} data={statisticContactsQuotes} />
                            </div>
                        </Zoom>
                    </Col>
                </Row>
            </div>

        )

    }

}

export default AdminStatistic